import React from 'react'

import FeatureCheck from 'components/FeatureCheck'
import HighlightedText from 'components/HighlightedText'

/** @type {import("./types").default} */
const FeatureHighlighted = ({ highlight, children, ...props }) => (
  <FeatureCheck className="FeatureHighlighted" {...props}>
    <HighlightedText highlight={highlight}>{children}</HighlightedText>
  </FeatureCheck>
)

export default FeatureHighlighted
